// @ts-expect-error File is untyped
import { getInitialOptinView } from 'ui-addon-opt/state/UIOptAvailability';
export const MARKETING_STUDIO_OPTIN_NAME = 'Marketing Studio';
export const isViewOptedOut = optinView => {
  return optinView === 'CURRENT';
};
export const getCachedOptinView = (() => {
  let cachedOptinView;
  return async cacheUpdateValue => {
    if (cacheUpdateValue !== undefined) {
      cachedOptinView = cacheUpdateValue;
      return cachedOptinView;
    }
    if (cachedOptinView !== undefined) {
      return cachedOptinView;
    }
    const optinView = await getInitialOptinView(MARKETING_STUDIO_OPTIN_NAME);
    cachedOptinView = optinView;
    return cachedOptinView;
  };
})();
export const getIsOptedInForMarketingStudio = async cacheUpdateValue => {
  const optinView = await getCachedOptinView(cacheUpdateValue);
  return !isViewOptedOut(optinView);
};